import i18next from 'i18next';

import { formatDate, subDate } from 'common/utils/dates';

export const getTodayDate = (format = 'dd/MM/yyyy') =>
    formatDate(new Date(), format);

export const getPastDate = (value, format = 'dd/MM/yyyy') =>
    formatDate(subDate(new Date(), { days: value }), format);

export const getStatusOptions = () => [
    {
        label: i18next.t('All text', { context: 'male', count: 2 }),
        value: 'all',
    },
    {
        label: i18next.t('Draft'),
        value: 0,
    },
    {
        label: i18next.t('Generated'),
        value: 1,
    },
];

export const getUserOptions = (users) => {
    const items = users.map((item) => {
        return {
            label: `${item.first_name} ${item.last_name}`,
            value: item.id,
        };
    });

    return [
        {
            label: i18next.t('All text', { context: 'male', count: 2 }),
            value: 'all',
        },
        ...items,
    ];
};
